import React, { useEffect, useState } from 'react';
import { ShieldAlert, LogOut, Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

// Persistent, high-visibility banner shown ONLY while the Root Admin is in an
// active roleplay/impersonation session. Renders across every route (mounted at
// the app root) and offers a one-click exit that restores the Root Admin view.
export const RoleplayBanner = () => {
  const { user, stopImpersonation } = useAuth();
  const [busy, setBusy] = useState(false);
  const imp = user?.impersonation;
  const active = !!imp?.active;

  useEffect(() => {
    if (active) document.body.classList.add('roleplay-active');
    else document.body.classList.remove('roleplay-active');
    return () => document.body.classList.remove('roleplay-active');
  }, [active]);

  if (!active) return null;

  const exit = async () => {
    setBusy(true);
    try { await stopImpersonation(); } catch { setBusy(false); }
  };

  const role = [imp.target_role, imp.target_department].filter(Boolean).join(' · ');
  return (
    <>
      <style>{`
        body.roleplay-active { padding-top: 44px; }
        body.roleplay-active .h-screen { height: calc(100vh - 44px); }
      `}</style>
      <div data-testid="roleplay-banner"
        className="fixed inset-x-0 top-0 z-[400] flex h-11 items-center justify-between gap-3 bg-gradient-to-r from-[#6E4600] via-[#8A5200] to-[#B26A00] px-4 text-white shadow-lg">
        <div className="flex min-w-0 items-center gap-2.5">
          <ShieldAlert className="h-4 w-4 shrink-0 text-amber-200" />
          <span className="truncate text-[13px] font-semibold" data-testid="roleplay-banner-text">
            ACTIVE ROLEPLAY SESSION: Viewing as {imp.target_name}{role ? ` (${role})` : ''} • Initiated by {imp.impersonator_name || 'Root Admin'}
          </span>
        </div>
        <button data-testid="roleplay-exit-btn" onClick={exit} disabled={busy}
          className="flex shrink-0 items-center gap-1.5 rounded-lg bg-white px-3 py-1.5 text-[12px] font-extrabold uppercase tracking-wide text-[#8A5200] transition hover:bg-amber-50 disabled:opacity-60">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <LogOut className="h-3.5 w-3.5" />}Exit Roleplay
        </button>
      </div>
    </>
  );
};
